import { useTranslation } from "react-i18next";

export default function Marquee() {
    const { t } = useTranslation();
    const cityList = t("marquee.cities", { returnObjects: true });
    const words = Array.isArray(cityList) ? cityList : [];
    const items = [...words, ...words];

    return (
        <section className="relative border-y overflow-hidden py-6 pr-24 sm:pr-6" style={{ borderColor: "rgba(255,255,255,0.06)" }} data-testid="marquee">
            <div className="marquee-track gap-16 items-center">
                {items.map((w, i) => (
                    <div key={i} className="flex items-center gap-16 shrink-0">
                        <span className="font-serif text-3xl md:text-5xl text-white/80 italic tracking-tight whitespace-nowrap">
                            {w}
                        </span>
                        <span className="w-2 h-2 rounded-full shrink-0" style={{ background: "var(--gold)" }} />
                    </div>
                ))}
            </div>
        </section>
    );
}
